import styled from "styled-components";

const SpinnerContainer = styled.div`
    display: flex;
    min-height: 30rem;
    align-items: center;
`;

export default SpinnerContainer;